import App from '../App'

const study = r => require.ensure([], () => r(require('../page/study/studyList')), 'study')
const myself = r => require.ensure([], () => r(require('../page/myself/myself')), 'myself')
const avatar = r => require.ensure([], () => r(require('../page/myself/avatar')), 'avatar')
const myShop = r => require.ensure([], () => r(require('../page/myself/children/myShop')), 'myShop')
const myOrderList = r => require.ensure([], () => r(require('../page/myOrderList/myOrderList')), 'myOrderList')
const bindPhone = r => require.ensure([], () => r(require('../page/myself/bindPhone')), 'bindPhone')
const signCardCom = r => require.ensure([], () => r(require('../page/educationalSystem/signCardCom')), 'signCardCom')

const yzgxStudy = r => require.ensure([], () => r(require('../page/yzgx/studyList')), 'yzgxStudy')
const yzgxVip = r => require.ensure([], () => r(require('../page/yzgx/vipPages')), 'yzgxVip')
const yzgxMall = r => require.ensure([], () => r(require('../page/yzgx/mall')), 'yzgxMall')
const yzgxExperience = r => require.ensure([], () => r(require('../page/yzgx/experienceClass')), 'yzgxExperience')

// vip相关页面
const vip = r => require.ensure([], () => r(require('../page/vip/vipPages')), 'vip')
const sendVip = r => require.ensure([], () => r(require('../page/vip/sendVip')), 'sendVip')
const sendVipHistory = r => require.ensure([], () => r(require('../page/vip/sendVipHistory')), 'sendVipHistory')

// 学习课程相关
const studySys = r => require.ensure([], () => r(require('../page/educationalSystem/studySys')), 'studySys')
const studyCard = r => require.ensure([], () => r(require('../page/educationalSystem/signCard')), 'signCard')
const packInfo= r => require.ensure([], () => r(require('../page/educationalSystem/packInfo')), 'packInfo')
const clockCashback = r => require.ensure([], () => r(require('../page/vip/clockcashback')), 'clockCashback')
const studyCenter= r => require.ensure([], () => r(require('../page/educationalSystem/studyCenter')), 'studyCenter')
const shortVideo= r => require.ensure([], () => r(require('../page/educationalSystem/shortVideo')), 'shortVideo')

//通用学习中间页（除训练营）
const planSys = r => require.ensure([], () => r(require('../page/educationalSystem/planSys')), 'planSys')
const phoneLogin = r => require.ensure([], ()=> r(require('../page/login/phoneLogin')), 'phoneLogin')
const page404 = r => require.ensure([], ()=> r(require('../page/error/404')), 'page404')

export default [{
    path: '',
    component: App, //顶层路由，对应index.html
    children: [ //二级路由。对应App.vue
        //地址为空时跳转发现页（）
        {
            path: '',
            redirect: 'yzgxStudy'
        },
        //学习
        {
            path: 'yzgxStudy',
            meta: {
                title: '学习'
            },
            component: yzgxStudy,
        },
        //vip
        {
            path: 'yzgxVip',
            meta: {
                title: '会员'
            },
            component: yzgxVip,
        },
        //mall
        {
            path: 'yzgxMall',
            meta: {
                title: '商城'
            },
            component: yzgxMall,
        },
        // 体验课
        {
            path: 'yzgxExperience',
            meta: {
                title: '元知国学体验课'
            },
            component: yzgxExperience,
        },
        //训练营-计划
        {
            path: 'planSys',
            meta: {
                title: '计划'
            },
            component: planSys,
        },
        //训练营-学习
        {
            path: 'studySys',
            meta: {
                title: '学习'
            },
            component: studySys,
        },
        //学习中心
        {
            path: 'studyCenter',
            meta: {
                title: ' '
            },
            component: studyCenter,
        },
        //短视频
        {
            path: 'shortVideo',
            meta: {
                title: '老师分享'
            },
            component: shortVideo,
        },
        {
            path: 'studyCard',
            meta: {
                title: '签到打卡'
            },
            component: studyCard,
        },
        //训练营-拆书包详情
        {
            path: 'packInfo',
            meta: {
                title: '今日学习'
            },
            component: packInfo,
        },
        //学习
        {
            path: 'study',
            meta: {
                title: '学习'
            },
            component: study,
        },
        //学习
        {
            path: 'signCardCom',
            meta: {
                title: '签到卡片'
            },
            component: signCardCom,
        },
        {
            path: 'vip',
            meta: {
                title: '会员'
            },
            component: vip,
        },
        //礼品卡分享
        {
            path: 'sendVip',
            meta: {
                title: 'vip体验卡'
            },
            component: sendVip,
        },
        //礼品卡赠送记录
        {
            path: 'sendVipHistory',
            meta: {
                title: '赠卡记录'
            },
            component: sendVipHistory,
        },
        //会员打卡日历页面
        {
            path: 'clock_cashback',
            meta: {
                title: '元知课堂学习数据'
            },
            component: clockCashback,
        },
        //我的
        {
            path: 'myself',
            meta: {
                title: '我的'
            },
            component: myself,
        },
        //修改头像
        {
            path: 'avatar',
            meta: {
                title: '修改头像'
            },
            component: avatar,
        },
        {
            path: 'myOrderList',
            meta: {
                title: '订单中心'
            },
            component: myOrderList,
        },
        {
            path: 'bindPhone',
            meta: {
                title: '请填写信息'
            },
            component: bindPhone,
        },
        //已购
        {
            path: 'myShop',
            meta: {
                title: '已购',
            },
            component: myShop,
        },
        // phoneLogin
        {
            path: 'phoneLogin',
            component: phoneLogin,
            meta: {
                title: '登录'
            }
        },
        //404
        {
            path: '404',
            component: page404,
            meta: {
                title: '404'
            }
        },

    ]
}]
